<template>
  <div class="sel">
    <div role="document">
      <div class="modal-content">
        <div class="modal-header" >
          <span class="modal-title">选择物品</span>
          <span aria-hidden="true" class="modal-span" @click="close">&times;</span>
        </div>
        <div class="modal-body">
          <!-- <form class="form-inline">
            <div class="form-group">
              <label for="exampleInputName2" class="lab">item_id</label>
              <input type="text" class="form-control" v-model="in_id" :placeholder="enter_name">
            </div>
            <div class="form-group">
              <label for="exampleInputEmail2" class="lab">name</label>
              <input type="email" class="form-control" v-model="in_name" :placeholder="id_number">
            </div>
            <button type="button" class="btn btn-default-determine" @click="btn_query">{{query}}</button>
          </form> -->
          <table class="table table-hover text-nowrap" v-if="$route.path=='/bin/Tank/Launcher/tbl_item'">
            <thead>
              <tr>
                <th>item_id</th>
                <th>name</th>
                <th>describe</th>
                <th>{{choice}}</th>
              </tr>
            </thead>
            <tbody class="tbody">
                <tr v-for="(data,index) in res_data" :key="index" @click="select_list(data.item_id)">
                  <td>{{data.item_id}}</td>
                  <td>{{data.name}}</td>
                  <td>{{data.describe}}</td>
                  <td><input type="checkbox" :value="data.item_id" v-model="btn_slecte"></td>
                </tr>
            </tbody>
          </table>
          <table class="table table-hover text-nowrap" v-if="$route.path=='/Sandbox/Other/EmailTitle'||$route.path=='/Sandbox/Other/EmailSiTitle'">
            <thead>
              <tr>
                <th>item_id</th>
                <th>name</th>
                <!-- <th>describe</th> -->
                <th>{{choice}}</th>
              </tr>
            </thead>
            <tbody class="tbody">
                <tr v-for="(data,index) in res_data" :key="index" @click="select_list(data.fld_unique_id)">
                  <td>{{data.fld_unique_id}}</td>
                  <td>{{data.fld_name}}</td>
                  <!-- <td>{{data.describe}}</td> -->
                  <td><input type="checkbox" :value="data.fld_unique_id" v-model="btn_slecte"></td>
                </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="z_cancel">{{cancel}}</button>
          <button type="button" class="btn btn-default-determine" @click="z_confirm">{{confirm}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name:'sel',
    data () {
    return {
      selected: '',
      //接口数据
      res_data:'',
      //副本数据
      copy_data:'',
      //输入id数据
      in_id:'',
      //输入物品名数据
      in_name:'',
      //复选框中的value
      btn_slecte:[],
    }
    },
    props: {
      ppr_action:String,
      ppr_action_param:String,
      box_fun:Object,
      //编辑框中的数据
      rule_data:String,
      del_data:Array
    },
    computed:{
      choice(){
        return this.$attrs.language_pack[this.sel_language].choice
      },
      query(){
        return this.$attrs.language_pack[this.sel_language].query
      },
      id_number(){
        return this.$attrs.language_pack[this.sel_language].id_number
      },
      enter_name(){
        return this.$attrs.language_pack[this.sel_language].enter_name
      },
      // head_title(){
      //   return '--'+this.$attrs.language_pack[this.sel_language].select_distribution_package+'--'
      // },
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
      ...mapState({
        sel_language:'sel_language'
      })
    },
    mounted () {  
      // alert(0)
      // console.log(this.rule_data_a)
      if(this.del_data){
        this.del_data.forEach((item,index)=>{
          this.select_list(item.item_id)
        })
      }


      // console.log(this.rule_data)
      // console.log(this.$route.path)
      if(this.$route.path=='/Sandbox/Other/EmailTitle'||this.$route.path=='/Sandbox/Other/EmailSiTitle'){

        this.axios.get(this.api+'/bin/Sandbox/Launcher/tbl_goods/datas'+'?userInfo='+window.sessionStorage.getItem('userInfo')).then((res)=>{
          // console.log(res.data)
          this.res_data=res.data;
        })
      }
      if(this.$route.path=='/bin/Tank/Launcher/tbl_item'){
        this.axios.get(this.api+this.box_fun.ACTION_DATA_URL+'/summary'+'?userInfo='+window.sessionStorage.getItem('userInfo')).then((res)=>{
          this.res_data=res.data;
          //副本
          this.copy_data=res.data;
        })
      }
      
    },
    methods: {
      //查询按钮
      btn_query(){
      if(this.in_id==''&&this.in_name==''){
        this.res_data='';
      }else if(this.in_id!=''&&this.in_name!=''){
        this.res_data=this.copy_data.filter((item,index)=>{
          return item.item_id==this.in_id&&item.name==this.in_name
        })
      }else if(this.in_id!=''){
        this.res_data=this.copy_data.filter((item,index)=>{
          return item.item_id==this.in_id
        })
      }else if(this.in_name!=''){
        this.res_data=this.copy_data.filter((item,index)=>{
          return item.name==this.in_name
        })
      }
      },
      //点击列表选中复选框
      select_list(id){
        // alert(0)
        // console.log(id)
      if(this.btn_slecte.length>0){
        //  this.btn_slecte.forEach((item,index)=>{
           if(this.btn_slecte.every((item1)=>{return id!=item1})){
             this.btn_slecte.push(id)
           }else{
             this.btn_slecte=this.btn_slecte.filter((item,index)=>{
               return item!=id
             })
           }
        //  })
      }else{
         this.btn_slecte.push(id)
      }
      // console.log(this.btn_slecte)
      },
      //取消按钮
      z_cancel(){
      this.btn_slecte=[];
      },
      //关闭按钮
      close(){
      this.$emit("sle_btn")
      },
      z_confirm(){
      var data=[];
      var obj={};
      if(this.btn_slecte.length>0){
        this.res_data.forEach((item,index)=>{
          this.btn_slecte.forEach((ite,i)=>{
            if(item.item_id&&item.item_id==ite){
              data.push({item_id:ite,name:item.name})
            }   
            if(item.fld_unique_id&&item.fld_unique_id==ite){
              data.push({item_id:ite,name:item.fld_name})
            }
          })
        })
      }else{
        data=[];
      }
      // console.log(data)
      this.$emit("selecte_btn",data)
      }
    },
    components: {

    },
    directives: {
      drag1: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
            //算出鼠标相对元素的位置
            let disX = e.clientX - drag_Box.offsetLeft;
            let disY = e.clientY - drag_Box.offsetTop;
            document.onmousemove = e => {
              //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              let left = e.clientX - disX;
              let top = e.clientY - disY;
              //移动当前元素
              drag_Box.style.left = left + "px";
              drag_Box.style.top = top + "px";
            };
            document.onmouseup = e => {
              //鼠标弹起来的时候不再移动
              document.onmousemove = null;
              //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
              document.onmouseup = null;
            };
          };
        }
      }
    }
  }
</script>
<style scoped>
   .table{
       margin-top: 10px;
   }
   .tbody{
       font-size: 14px;
   }
   .form-control{
       margin-right: 10px;
       width: 140px;
       height: 30px;
       font-size: 13px;
   }
   .lab{
       margin-right: 10px;
   }
   .form-inline{
       font-size: 14px;
   }
   .sel{
    position: fixed;
    top: 30%;
    left: 20%;
    min-width: 846px;
    z-index:999
    /* transform: translate(-40%, -40%); */
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
  }
  .text{
    margin: 0 auto;
    display: block;
    outline: none;
  }
  .modal-header{
	  background:#ebecf0;
	  height:40px
	}
  .modal-span{
	  font-size:20px;
	  margin-top:-14px;
	  cursor:pointer
	}
  .modal-title{
	  line-height:1px
	}
  .btn-default-close{
    color:#007bff;
	  font-size:12px;
	  border:1px solid #808080;
	  padding:4px;
	  /* margin-right: 90%; */
  }
  .modal-footer{
    justify-content: space-between;
  }
  .btn-default-determine{
    color:#007bff;
	  font-size:12px;
	  border: 1px solid rgb(128, 128, 128);
	  padding: 4px;
  }
  .modal-header{
      cursor: move;
    }
</style>